import utils from 'utils'
class scrollService {
    constructor(logger, httpRequest) {
        this.onScrollTop = function (currentDetail,pageParam,loadSize,cb) {
            const detail = currentDetail
            let returnPageParam = pageParam
            if (detail.hasPreviousPage) { // 存在上一页 
                const currentPageNum = detail.pageNum
                const startPoint = (currentPageNum - 1) * loadSize - loadSize // 正常情况下起始点
                const endPoint = (currentPageNum - 1) * loadSize > detail.total ? detail.total : (currentPageNum - 1) * loadSize
                const msg = `正在加载${startPoint + 1}-${endPoint}条商品明细,共${detail.total}条`
                utils.loading(msg)
                returnPageParam.pageNum = detail.prePage
                cb(returnPageParam)
                $scope.$apply()
                setTimeout(() => {
                    $('.slimScrollBar').css({
                        top: 0.5,
                    })
                    utils.loaded()
                }, 2000)
            } else {
                console.log('到顶啦！！')
            }
            return returnPageParam
        }
        this.onScrollDown = function (currentDetail,pageParam,loadSize,cb) {
            const detail = currentDetail
            let returnPageParam = pageParam
            if (detail.hasNextPage) { // 存在下一页 
                const currentPageNum = detail.pageNum
                const startPoint = (currentPageNum + 1) * loadSize - loadSize // 正常情况下起始点
                let endPoint = (currentPageNum + 1) * loadSize
                if ((currentPageNum + 1) * loadSize > detail.total) { // 总条数小于endpoint
                    endPoint = detail.total
                }
                if (detail.total < currentPageNum * loadSize + 20) { // 总条数大于endpoint但是小于endpoint+20(大于20条才会出现滚动条)
                    endPoint = detail.total
                }

                const msg = `正在加载${startPoint + 1}-${endPoint}条商品明细,共${detail.total}条`
                utils.loading(msg)
                returnPageParam.pageNum = detail.nextPage
                cb(returnPageParam)
                $scope.$apply()
                console.log($('.slimScrollBar'))
                setTimeout(() => {
                    if (detail.total < (loadSize * currentPageNum + 20)) {
                        $('.slimScrollBar').css({
                            bottom: 8,
                        })
                    } else {
                        $('.slimScrollBar').css({
                            top: 0.5,
                        })
                    }
                    utils.loaded()
                }, 2000)
            } else {
                console.log('到底啦！！')
            }
            return returnPageParam
        }
    }
}

scrollService.$inject = ['logger','httpRequest']
export default scrollService



// WEBPACK FOOTER //
// ./src/common/services/scrollService.js